import React, { createContext, useContext, useState, ReactNode } from "react";

export interface User {
  id?: string | null;
  api_key: string | null;
  user_id: string | null;
  tenant_id: string | null;
  role_id: string | null;
  email: string | null;
  company_name: string | null;
  user_name: string | null;
  profile_image_url: string | null;
  social_listening_access?: boolean | null;
  first_name?: string | null;
  last_name?: string | null;
  phone_number?: string | null;
  status?: boolean;
}

interface UserContextType {
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);

  return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>;
};

export const useUser = (): UserContextType => {
  const context = useContext(UserContext);
  if (!context) {throw new Error("useUser must be used within a UserProvider");}
  return context;
};
